import Pubnub from 'pubnub';

export enum StoryCoEditingMessageType {
	join = 'story.join',
}

export type StoryPubnubMessage = Pubnub.FetchMessagesResponse['channels'][string][number];

export interface StoryJoinMessage extends StoryPubnubMessage {
	message: {
		type: StoryCoEditingMessageType.join;
		email: string;
		name: string;
	};
}

export interface StoryJoinMessageEvent extends Pubnub.MessageEvent {
	message: {
		type: StoryCoEditingMessageType.join;
		email: string;
		name: string;
	};
}

export type StoryChannelOccupant = {
	uuid: string;
};

export function isOccupiedBy(msg: StoryPubnubMessage | undefined, uuid: string): msg is StoryJoinMessage {
	return msg !== undefined && msg?.message?.type === StoryCoEditingMessageType.join && msg.uuid !== uuid;
}

export function isJoinMessageEvent(msgEvent: Pubnub.MessageEvent): msgEvent is StoryJoinMessageEvent {
	return msgEvent !== undefined && msgEvent?.message?.type === StoryCoEditingMessageType.join;
}

export function hasOtherOccupant(occupants: StoryChannelOccupant[] | undefined, userId: string | undefined): boolean {
	if (!userId || !occupants?.length) {
		return false;
	}

	return occupants.some(occupant => occupant.uuid !== userId);
}
